import { useMemo } from 'react'

import { AuthorizationEntry } from '../../sdk'

const useAuthorizations: (authorizations: AuthorizationEntry[] | undefined) => {
  sortedAuthorizations?: AuthorizationEntry[]
  previousTotal?: number
} = (authorizations) => {
  const sortedAuthorizations = useMemo(
    () =>
      authorizations &&
      authorizations
        .slice()
        .sort(
          (a, b) => a.info!.dateTime!.valueOf() - b.info!.dateTime!.valueOf()
        ),
    [authorizations]
  )

  const previousTotal =
    sortedAuthorizations && sortedAuthorizations.length > 0
      ? sortedAuthorizations[sortedAuthorizations.length - 1].info!.amount
      : undefined

  return {
    sortedAuthorizations,
    previousTotal
  }
}

export default useAuthorizations
